import { useCallback, useMemo } from 'react';
import { RootState, useAppDispatch, useAppSelector } from '../store';
import { UserSettings } from '../Types';
import { credentialsService } from '../Services/credentialsService';
import { PaginationListType } from '../Types/PaginationParams';
import { setListReloadType } from '../Store/features/environment/environmentSlice';
import toast from 'react-hot-toast';
import useModal from '../components/Modal/useModal';
const useCredentials = () => {
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const dispatch = useAppDispatch();
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const modal = useModal();

    const deleteCredential = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;
            credentialsService.deleteCredential(identifier).then((response) => {
                if (response.data.success) {
                    dispatch(setListReloadType(PaginationListType.Credentials));
                } else {
                    toast.error(
                        i18n.translate({
                            id: 'credentialDelete.error',
                            sourceName: 'Credentials',
                        }),
                    );
                }
            });
        },
        [userSettings.isLoggedIn, dispatch, i18n],
    );

    const handleOpenConfirmDialog = useCallback(
        (credentialIdentifier: string) => {
            modal.deleteConfirm({
                title: i18n.translate({ id: 'credentialDelete.title', sourceName: 'Credentials' }),
                content: i18n.translate({ id: 'credentialDelete.text', sourceName: 'Credentials' }),
                onConfirm: () => deleteCredential(credentialIdentifier),
            });
        },
        [modal, deleteCredential, i18n],
    );

    const CredentialsActions = useMemo(
        () => ({
            handleOpenConfirmDialog,
        }),
        [handleOpenConfirmDialog],
    );

    return {
        CredentialsActions,
    };
};

export default useCredentials;
